import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/shared/loading.service';
import { v4 } from 'uuid';
import { environment } from '../../../environments/environment';
import { UsersApplicationsService } from '../../modal-open-application/users-applications.service';

@Component({
  selector: 'app-signup-a-client',
  templateUrl: './signup-a-client.component.html',
  styleUrls: ['./signup-a-client.component.scss'],
})
export class SignupAClientComponent implements OnInit {
  fullName: string = '';
  email: string = '';
  phone: string = '';
  errorMessage: string = '';
  isFullNameValid: boolean = true;
  application: string;

  constructor(
    private loadingService: LoadingService,
    private toste: ToastrService,
    private userService: UsersApplicationsService,
    private dialog: MatDialog,
    private route: Router
  ) {}

  ngOnInit(): void {
    this.application = this.loadingService.getLoadingState();
    this.removeCookies()
    this.dialog.closeAll();
  }

  validateFullName(): void {
    this.isFullNameValid = this.fullName.trim().includes(' ');
  }

  formatPhoneNumber(): void {
    const cleaned = this.phone.replace(/\D/g, '');
    this.phone = cleaned
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2');
  }
  onlyAllowNumbers(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  
  create(clientId: string) {
    this.openLink(v4(), clientId);
  }
  openLink(id: string, clientId: string) {
    const aplicationselector = this.loadingService.getLoadingState();
    this.userService.getAccessToken(clientId, aplicationselector, id)
    .subscribe((response: any) => {
      this.openFolder(response.accessToken, clientId);
    },() => {
      alert('Tivemos um problema ao abrir a pasta deste usuário.')
    })
  }
  openFolder(token: string, clientId: string) {
    const aplicationselector = this.loadingService.getLoadingState();

    if (aplicationselector === 'guia') {
      this.userService.createStudy(clientId, token).subscribe(
        (res: any) => {
          if (res.success && this.saveGuiaSession(res.data.id, token)) {
            location.href = 'https://guia.techfinance.com.br/home';
            return;
          }

          this.showError('Erro ao salvar os dados de sessão. Tente novamente.');
        },
        (error) => {
          console.error('Erro ao criar estudo:', error);
          this.showError('Erro ao criar estudo. Tente novamente.');
        }
      );
      return;
    }

    location.href = environment.clientRedirect.replace('techfinance', aplicationselector + '.techfinance').replace('.qa.', '.') + '/folder-token/callback/' + token;
  }

  onSubmit() {
    if (!this.isFullNameValid || !this.email || !this.phone) {
      this.errorMessage = 'Por favor, preencha todos os campos corretamente.';
      return;
    }

    const userData = {
      fullName: this.fullName,
      email: this.email,
      phone: this.phone.replace(/\D/g, ''),
      origin: 'pasta:userid',
    };

    this.userService.createUserFromZero(userData).subscribe(
      (response) => {
        this.toste.success(`Cliente "${userData.fullName}" foi cadastrado`);
        const userId = response._id
        this.create(userId)
      },
      (error) => {
        this.errorMessage = error.error.message || 'Ocorreu um erro no cadastro.';
      }
    );
  }

  private removeCookies() {
    console.log(this.application)
    if (this.application === 'guia') {
      document.cookie =
        'formsId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
      document.cookie =
        'studyId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
      document.cookie =
        'clientName=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
        console.log("Cookies apagados")
    }
  }

  private saveGuiaSession(studyId: number | string, token: string): boolean {
    try {
      if (!token) {
        this.showError('Token de acesso não encontrado. Tente novamente.');
        return false;
      }

      localStorage.setItem('studyId', String(studyId));
      document.cookie = `studyId=${studyId}; path=/; domain=.techfinance.com.br`;
      document.cookie = `token=${token}; path=/; domain=.techfinance.com.br`;
      document.cookie = `clientName=${this.fullName}; path=/; domain=.techfinance.com.br`;
      return true;
    } catch (error) {
      console.error('Erro ao salvar dados de sessão do Guia:', error);
      this.showError('Erro desconhecido ao salvar os dados de sessão. Tente novamente.');
      return false;
    }
  }

  private showError(message: string) {
    this.errorMessage = message;
    this.toste.error(message);
  }
}
